import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { store } from "./provider/store";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#0180FD", // đổi màu primary cho toàn bộ Ant Design
          colorPrimaryHover: "#0180FD", // màu hover (mạnh hơn hoặc nhẹ hơn)
          colorPrimaryBorder: "#0180FD", // màu viền input khi focus
        },
      }}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ConfigProvider>
  </Provider>
);
